import { useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';

import { selectBlackFriday, selectHasBlackFridayPromos } from '../../../selectors/blackFriday';
import { selectPlatform } from '../../../selectors/platform';

export const useAppRedirectBannerVisible = () => {
  const { isActive } = useSelector(selectBlackFriday);
  const isMobweb = useDeviceType() !== 'desktop';
  const hasBlackFridayPromos = useSelector(selectHasBlackFridayPromos);
  const platform = useSelector(selectPlatform);

  return isActive && isMobweb && hasBlackFridayPromos && ['ios', 'android'].includes(platform);
};
